import styled, { keyframes } from "styled-components";

const placeholderShimmer = keyframes`
  0% { background-position: -468px 0; }
  100%{ background-position: 468px 0; }
`

const Placeholder = styled.div<{ maxWidth?: string; height?: string }>`
    animation-duration: 1.5s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: ${placeholderShimmer};
    background: #f6f7f8;
    background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
    background-size: 800px 104px;
    height: ${({ height }) => (height ? height : "16px")};
    position: relative;
    width: ${({ maxWidth }) => (maxWidth ? maxWidth : "100%")};
    margin-bottom: 3px;
`;

export default Placeholder;
